<template>
  <div class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-3">
        <h5>ユーザー一覧</h5>
      </div>
      <div class="col-6 text-right">
        <button v-if="isAdmin && isFederation" id="createUserBtn" type="button" class="btn-sm btn-outline-info" v-on:click="create">新しく登録する</button>  
        <button v-if="isAdmin" type="button" class="btn-sm btn-outline-primary" v-on:click="importCsv">CSVをimportする</button>
        <b-dropdown v-if="isAdmin" text="CSVをexportする" size="sm" variant="outline-success" class="rounded" style="border:1px #0F0 groove" >
          <b-dropdown-item v-on:click="exportCsv('sjis')">Shift_JIS</b-dropdown-item>
          <b-dropdown-item v-on:click="exportCsv('utf8')">UTF-8</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <div class="row">
      <div class="col-1">
      </div>
      <div class="col-7">
          <div class="row">
            <div class="col-10">
              <form class="input-group" @submit.prevent="search(true)">
                <input type="text" class="form-control" v-model="searchKey" placeholder="ID、名称、かな"> 
                <div class="input-group-append">
                    <button class="btn btn-secondary" type="submit">
                      <img class="search-solid" src="/search-solid.svg">
                    </button>
                </div>
              </form>
            </div>
            <div class="col-2" style="white-space: nowrap;">  
              <div class="input-group-append">
              <b-button  
                v-b-toggle.collapse-1 
                variant="bg-white text-secondary" 
              ><span id="Arrow" v-bind:class="actionToggle" style="display:inline-block;"></span>詳細条件</b-button>
              </div>
            </div>  
          </div>  
      </div>
      <div id="sort-inline" class="col-2 form-group form-inline pr-0">
        <img class="sort-solid" src="/sort-alpha-down-solid.svg">
            <select id="sort-select" class="form-control" v-model="sortKey" v-on:change="search(true)">
                <option value="updatedAt">更新順</option>
                <option value="userCode">ID順</option>
                <option value="userKana">かな順</option>
            </select>
      </div>
    </div>
    <div class="row">
      <div class="col-1">
      </div>
      <div class="col-9">
        <b-collapse v-model="visible" id="collapse-1" class="mt-1">
          <b-card >
            <div class="row" v-if="isProfession">
              <div class="col-1" style="width:200px">
                <label class="col-sm col-form-label" style="white-space: nowrap;">職種</label>
              </div>
              <div class="col-4"> 
                <select class="form-control" v-model="searchProfession" v-on:keydown.enter="search(true)">
                  <option value=""></option>
                  <option value="1">医師</option>
                  <option value="8">麻酔科</option>
                  <option value="6">看護役職</option>
                  <option value="2">看護師</option>
                  <option value="5">看護補助</option>
                  <option value="4">薬剤師</option>
                  <option value="9">放射線技師</option>
                  <option value="10">臨床検査技師</option>
                  <option value="7">検査科</option>
                  <option value="11">保育士</option>
                  <option value="12">保育補助</option>
                  <option value="13">理学療法士</option>
                  <option value="14">管理栄養士</option>
                  <option value="15">社会福祉士</option>
                  <option value="16">救急救命士</option>
                  <option value="3">事務</option>
                  <option value="0">その他</option>
                </select>
              </div>
              <div class="col-1">
              </div>  
              <div class="col-1" >
                <label class="col-form-label" style="white-space: nowrap;">職種名称</label>
              </div>
              <div class="col-4">
                <form class="input-group" @submit.prevent="search(true)">
                  <input type="text" maxlength="40" v-model="searchProfessionText" class="form-control" autocomplete="off" placeholder="職種名称">
                </form>
              </div>
            </div>
            <div class="row" v-if="isProfessionText">
              <div class="col-1" >
                <label class="col-form-label" style="white-space: nowrap;">職種名称</label>
              </div>
              <div class="col-4">
                <form class="input-group" @submit.prevent="search(true)">
                  <input type="text" maxlength="40" v-model="searchProfessionText" class="form-control" autocomplete="off" placeholder="職種名称">
                </form>
              </div>
            </div>
            <div class="row">
              <p></p> 
            </div>  
            <div class="row">
              <div class="col-1">
                <label class="col-sm col-form-label" style="white-space: nowrap;">所属</label>
              </div>
              <div class="col-4">
                <select class="form-control" v-model="searchAffiliation" v-on:keydown.enter="search(true)">
                  <option value=""></option>
                  <option v-for="option in organizationOptions" v-bind:value="option.id" v-bind:key="option.id">
                    {{ option.displayName }}
                  </option>
                </select>
              </div>
              <div class="col-1">
              </div>  
              <div class="col-1">
                 <label class="col-form-label" style="white-space: nowrap;">肩書</label>
              </div>
              <div class="col-4">
                <form class="input-group" @submit.prevent="search(true)">
                  <input type="text" maxlength="40" v-model="searchDescription" class="form-control" autocomplete="off" placeholder="肩書">
                </form>
              </div>
              <div class="col-1">
              </div>
            </div>
            <div class="row">
              <p></p> 
            </div>  
            <div class="row">
              <div class="col-1">
                <label class="col-sm col-form-label" style="white-space: nowrap;">権限</label>
              </div>
              <div class="col-4"> 
                <select class="form-control" v-model="searchPrivilege" v-on:keydown.enter="search(true)">
                  <option value=""></option>
                  <option value="1">管理サイト使用不可</option>
                  <option value="2">管理権限</option>
                  <option value="3">管理サイト照会可能</option>
                  <option v-if="isSuper" value="9">システム管理権限</option>
                </select>
              </div>
              <div class="col-2 offset-4">  
                <button class="btn btn-outline-secondary" style="margin-left: 57px; white-space: nowrap;" type="submit" @click="clearSearch()" v-on:keydown.enter="search(true)">条件クリア</button>
              </div>   
            </div>        
          </b-card>  
        </b-collapse>
      </div>
      <div class="col-2">
      </div>  
    </div>
    <div class="row">
      <div class="col-1">
      </div>
      <!-- 現職/廃止済ユーザー 切り替えスイッチ ON(廃止済)でBOLDにする-->
      <div class="col-9">
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" id="customSwitches" v-on:click="switchDeleted" v-model="deleted">
          <label class="custom-control-label" v-bind:style="deleted? 'font-weight:bold' : ''" for="customSwitches">アカウント廃止日が設定済のユーザーを表示する</label>
        </div>
      </div>
    </div>
    <div class="row">
      <p></p> 
    </div>  
    <div id="main" class="row">
      <div class="col-1">
      </div>
      <div class="col-9">
        <table class="table table-dark table-sm table-hover">
          <thead>
            <tr>
              <th                scope="col" style="width:50px">#</th>
              <th                scope="col"></th>
              <th                scope="col">ID</th>
              <th                scope="col">名称</th>
              <th                scope="col">職種</th>
              <th                scope="col">所属</th>
              <th                scope="col">肩書</th>
              <th scope="col" style="width:150px">
                {{ isDisable ? "アカウント廃止日" : "番号" }}
              </th>
              <th v-if="isAdmin" scope="col" style="width:100px">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user, index) in users" v-bind:key="user.id">
              <th scope="row">{{ currentIndex * limit + index + 1 }}</th>
              <td><svg class="bd-placeholder-img rounded mr-2" width="15" height="15" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" ><rect v-bind:class="classOnOffColor(user)" width="100%" height="100%"/></svg></td>
              <td>{{ user.userCode }}</td>
              <td>{{ user.userName }}</td>
              <td>{{ user.profession }}</td>
              <td>{{ user.affiliation }}</td>
              <td>{{ user.description }}</td>
              <td v-if="!isDisable">
                <label v-show="user.status === 1 && user.expire === 0">{{ user.extensionNumber }}</label>
              </td>
              <td v-else>
                <label>{{ moment(user.disableAt) }}</label>
              </td>
              <td>
                <button v-if="isAdmin" type="button" class="btn-sm btn-light" v-on:click="modify(user.id)">編集する</button>
              </td>
            </tr>
          </tbody>
        </table>
        <nav aria-label="pager">
          <ul class="pagination justify-content-center">
            <li v-if="isPrev" v-on:click="goPrev">
              <a class="btn page-link rounded-pill">&larr; 前</a>
            </li>
            <li v-if="isPrev||isNext" class="mx-2">
              <a class="btn page-link rounded-pill">現在</a>
            </li>
            <li v-if="isNext" v-on:click="goNext">
              <a class="btn page-link rounded-pill">次 &rarr;</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-3">
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Encoding from 'encoding-japanese'
import authority from '../../authority'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'
import { saveAs } from 'file-saver';

export default {
  name: 'Index',
  mixins: [sessions,path,headers],
  props: ['realms', 'serviceName'],
  src: {
    authority
  },
  data: function(){
    return {
      users: [],
      organizationOptions: [],
      historyId: -1,
      searchKey: '',
      message: '',
      sortKey: 'updatedAt',
      gridCount: 0,
      currentIndex: 0,
      limit: 20,
      uploadFile: null,
      searchProfession: '',
      searchProfessionText: '',
      searchAffiliation: '',
      searchDescription: '',
      searchPrivilege: '',
      visible: false,
      deleted: false
    }
  },
  created () {
    if (this.serviceName === 'SmartPhone'){
      this.searchProfession = '',
      this.searchProfessionText = ''
    }
    if(this.$store.getters.userSearch.searchProfession === '' &&
      this.$store.getters.userSearch.searchProfessionText === '' &&
      this.$store.getters.userSearch.searchAffiliation === '' &&
      this.$store.getters.userSearch.searchDescription === '' &&
      this.$store.getters.userSearch.searchPrivilege === '') {
      this.visible = false
    } else{
      this.visible = true
    }
  },
  mounted() {
    if(this.$store.getters.userSearch.sortKey !== ''){
      this.sortKey = this.$store.getters.userSearch.sortKey
    }
    if(this.$store.getters.userSearch.searchKey !== ''){
      this.searchKey = this.$store.getters.userSearch.searchKey
    }
    if(this.$store.getters.userSearch.searchProfession !== ''){
      this.searchProfession = this.$store.getters.userSearch.searchProfession
    }
    if(this.$store.getters.userSearch.searchProfessionText !== ''){
      this.searchProfessionText = this.$store.getters.userSearch.searchProfessionText
    }
    if(this.$store.getters.userSearch.searchAffiliation !== ''){
      this.searchAffiliation = this.$store.getters.userSearch.searchAffiliation
    }
    if(this.$store.getters.userSearch.searchDescription !== ''){
      this.searchDescription = this.$store.getters.userSearch.searchDescription
    }
    if(this.$store.getters.userSearch.searchPrivilege !== ''){
      this.searchPrivilege = this.$store.getters.userSearch.searchPrivilege
    }
    if(this.$store.getters.userSearch.currentIndex !== 0){
      this.currentIndex = this.$store.getters.userSearch.currentIndex
    }
    if(this.$store.getters.deletedSwitch){
      this.deleted = this.$store.getters.deletedSwitch.isDisable
    }
    if(this.$store.getters.hospital.id !== 0){
      this.search(false)
      this.getCurrent()
      this.getOrganization()
    }
    this.$store.watch(
      (state, getters) => getters.hospital,
      (newValue, oldValue) => {
        if (newValue.id != oldValue.id) {
          this.search(true)
          this.getCurrent()
          this.getOrganization()
        }
      }
    )
  },
  computed: {
    isSuper: function () {
      return this.$store.getters.user.privilege === 9
    },
    actionToggle: function () {
      return {
        'Arrow-Top': this.visible === true,
        'Arrow-Bottom': this.visible === false
      }
    },
    isProfession: function (){
      return this.serviceName === 'Nichibyo'
    },
    isProfessionText: function (){
      return this.serviceName === 'SmartPhone'     
    },
    isNext: function () {
      return this.gridCount === this.limit
    },
    isPrev: function () {
      return this.currentIndex !== 0
    },
    isMessage: function () {
      return this.message.length > 0
    },
    isAdmin: function () {
      var overAdmin = authority.isAdmin.concat(authority.isSuper)
      return overAdmin.includes(Number(this.$store.state.user.privilege))
    },
    isFederation: function() {
      if(this.$store.getters.hospital.useFederation) {
        if(Number(this.$store.getters.user.privilege) === 9) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    isDisable: function () {
      return this.$store.getters.deletedSwitch.isDisable
    },
  },
  methods: {
    classOnOffColor: function (user) {
      return {
        online: user.status === 1 && user.expire === 0,
        offline: user.status === 0 || user.expire === 1,
      }
    }, 
    moment: function (date) {
      if (this.$moment(date).isValid()) {
        return this.$moment(date).format('YYYY年MM月DD日');
      } else {
        return '';
      }
    },
    getOrganization() {
      this.$cognito.isAuthenticated().then((session) => {
      var accessToken = this.getAccessToken(this.$cognito,session)
      var hospitalId = this.$store.getters.hospital.id
      axios.post("/api/organization/management/belonglist",{
        hospitalId: hospitalId,
        historyId: this.historyId
      }, {
        headers: this.headers(accessToken)
      }).then(response => {
        this.organizationOptions = response.data.data.organizations
      }).catch(err => {
        throw err
      })
      }).catch((err) => {
        this.message = err.message
      })
    },
    create() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/user/create'))
    },
    modify(id) {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/user/modify/'+id))
    },
    importCsv() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/common/user/import'))
    },
    exportCsv(type){
      var hospitalId = this.$store.getters.hospital.id
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          axios.get("/api/user/csv/" + hospitalId, {
                headers: this.headersUploadStream(accessToken)
          }).then((res) => {
            //csv download
            if (type === "utf8"){
                const fileName = 'users_utf8.csv'
                let blob = new Blob([res.data],{ type: "text/csv;charset=utf-8" });
                saveAs(blob, fileName); 
            } else if (type === "sjis"){
            // convert encoding. (utf-8 → shift-jis )
                const unicodeList = new Encoding.stringToCode(res.data);
                const shiftJisCodeList = Encoding.convert(unicodeList, 'sjis', 'unicode');
                const shiftJisString = new Uint8Array(shiftJisCodeList);
                const fileName = 'users_sjis.csv'
                let blob = new Blob([shiftJisString], {type: "text/csv;charset=sjis"})
                saveAs(blob, fileName);
            }   
          })
        }}).catch((err) => {
            this.message = err.message
      }) 
    },
    search(isInit) {
      this.$cognito.isAuthenticated().then((session) => {
      if(session){
        if(isInit){
          this.currentIndex = 0
        }
        var offset = this.currentIndex * this.limit
        var accessToken = this.getAccessToken(this.$cognito,session)
        var hospitalId = this.$store.getters.hospital.id
        var privilege = this.$store.getters.user.privilege
        if (this.searchKey != '' || this.searchProfession || this.searchProfessionText || this.searchDescription || this.searchPrivilege || this.searchAffiliation != "") {
          axios.post("/api/user/list/management" + "/" + offset, {
            hospitalId: hospitalId,
            searchKey: this.searchKey,
            sortKey: this.sortKey,
            privilege: privilege,
            searchProfession: this.searchProfession,
            searchProfessionText: this.searchProfessionText,
            searchAffiliation: this.searchAffiliation,
            searchDescription: this.searchDescription,
            searchPrivilege: this.searchPrivilege,
            isDisable: this.deleted === true ? 1 : 0
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            this.users = response.data.data.users.map(element => {
              if(this.sortKey !== 'userCode'){
              element.affiliation = element.organization === null ? "" : element.organization.affiliation
              } else{
                element.affiliation = element.organization === null ? "" : element.affiliation
              }
              return element  
            })
            this.gridCount = this.users.length
            this.$store.commit('userSearch',{
              sortKey: this.sortKey,
              searchKey: this.searchKey,
              searchProfession: this.searchProfession,
              searchProfessionText: this.searchProfessionText,
              searchAffiliation: this.searchAffiliation,
              searchDescription: this.searchDescription,
              searchPrivilege: this.searchPrivilege,
              currentIndex: this.currentIndex,
            })
          }).catch(err => {
            this.message = err.message
          })
        } else {
          var isDeleted = this.deleted === true ? 1 : 0
          axios.get("/api/user/list" + "/" + hospitalId + "/" + offset + "/" + this.sortKey + "/" + privilege + "/" + isDeleted + "/", {
            headers: this.headers(accessToken)
          }).then(response => {
            this.users = response.data.data.users.map(element => {
              if(this.sortKey !== 'userCode'){
              element.affiliation = element.organization === null ? "" : element.organization.affiliation
              } else{
                element.affiliation = element.organization === null ? "" : element.affiliation
              }
              return element         
            })
            this.$store.commit('deletedSwitch',{
              isDisable: this.deleted,
            })
            this.gridCount = this.users.length
            this.$store.commit('userSearch',{
              sortKey: this.sortKey,
              searchKey: '',
              searchProfession: '',
              searchProfessionText: '',
              searchAffiliation: '',
              searchDescription: '',
              searchPrivilege: '',
              currentIndex: this.currentIndex
            })
          }).catch(err => {
            this.message = err.message
            this.$store.commit('userSearch',{
              sortKey: '',
              searchKey: '',
              searchProfession: '',
              searchProfessionText: '',
              searchAffiliation: '',
              searchDescription: '',
              searchPrivilege: '',
              currentIndex: 0
            })
          })
        }
      } else {
       this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
      }}).catch((err) => {
        this.message = err.message
      })
    },
    goNext(){
      this.currentIndex++
      this.search(false)
    },
    goPrev(){
      this.currentIndex--
      this.search(false)
    },
    getCurrent() {
      if(this.$store.getters.organization){
        this.historyId = this.$store.getters.organization.historyId
        return Promise.resolve();
      } else {
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var hospitalId = this.$store.getters.hospital.id
          axios.get("/api/organization/management/current/" + hospitalId, {
            headers: this.headers(accessToken)
          }).then(response => {
            var data = response.data.data
            if(data){
              var organization = data.organization
              this.$store.commit('organization',{
                  startAt: organization.startAt,
                  historyId: organization.historyId
              })
            }
          }).catch(err => {
            throw err
          })
      } else {
        this.$router.replace(this.replacePath(this.$cognito,this.realms,'/login'))
      }}).catch((err) => {
        this.message = err.message
      })
      }
    },
    clearSearch(){           
      this.searchProfession = '',
      this.searchProfessionText = '',
      this.searchAffiliation = '',
      this.searchDescription = '',
      this.searchPrivilege = ''
      this.$store.commit('userSearch',{
        sortKey: this.sortKey,
        searchKey: this.searchKey,
        searchProfession: '',
        searchProfessionText: '',
        searchAffiliation: '',
        searchDescription: '',
        searchPrivilege: '',
        currentIndex: this.currentIndex
      })
    },
    switchDeleted(){
      this.deleted = !this.deleted
      this.$store.commit('deletedSwitch',{
        isDisable: this.deleted,
      })
      this.currentIndex = 0
      this.search(false)
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
#main {
  height: 100%;
}
.btn-sm{
  margin-right: 10px;
}
.search-solid{
  cursor: pointer;
  height: 18px;
  width: 18px;
}
.sort-solid{
  height: 25px;
  width: 25px;
  margin-right: 10px;
}
#sort-select{
  width: 70%;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.online {
  fill: #FF4E00
}
.offline {
  fill: #D9D9D9
}
.Arrow-Bottom {
  border-bottom: solid 2px #7c7d7d;
  border-right: solid 2px #7c7d7d;
  width: 8px;
  height: 8px;
  transform: rotate(45deg);
  margin-bottom: 3px;
  margin-right: 5px;
}
.Arrow-Top {
  border-top: solid 2px #7c7d7d;
  border-left: solid 2px #7c7d7d;
  width: 8px;
  height: 8px;
  transform: rotate(45deg);
  margin-right: 5px;
}
</style>